import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Subject } from 'rxjs';

@Injectable({
   providedIn: 'root'
})
export class InputService {

   private _input = new BehaviorSubject({});
   input = this._input.asObservable();

   private _eventoInput = new Subject();
   eventoInput = this._eventoInput.asObservable();

   constructor() { }

   mostrarInput(tipo: number, datos: any) {
      this._input.next( {'tipo': tipo, 'datos': datos} );
   }

   emitirEvento( event ) {
      this._eventoInput.next(event);
   }
}
